import store from "@/services/store";
function nameEntidad(values,indexGet)
{
	let entidad= ''
	entidad=_.filter(store.state.crudStore.lists[values[0]],['id',values[1]])[0].name	
	return entidad
}
export default {
	data(){
		return {
			tableGBoptions: { 
				modals: [
					{
						modal: "Editar",
						icon: "pencil",
						title: "Editar Incapacidad",
						variant: 'primary',						
						movil:true
					},
					{
						modal: "Egresos",
						icon: "credit-card",
						title: "Crear Egreso",
						variant: 'secondary',						
						movil:true
					},
					{
						modal: "Eliminar",
						icon: "x-circle",
						title: "Eliminar incapacidad",
						variant: 'danger',						
						movil:true
					},
				]
			},

			tableGBSearch: ['datos_afiliado/name','datos_afiliado/documento','datos_razon/name','info_incapacidades/id_list_proceso'],
			
			tableGBItems: [				
				{
					thead: { th: 'Documento', sort: null, sortTable: 'datos_afiliado/documento'},
					tbody: { td: ['datos_afiliado/documento'],}
				},			
				{
					thead: { th: 'Nombres', sort: null, sortTable: 'datos_afiliado/name'},
					tbody: { td: ['datos_afiliado/name'],}
				},
				{
					thead: { th: 'Razón', },
					tbody: { td: ['datos_razon/name'],}
				},
				{
					thead: { th: 'Entidad', sort: null, sortTable: 'info_incapacidades/name_entidad' },
					tbody: { td: ['info_incapacidades/name_list','info_incapacidades/name_entidad'], ftn: function (values,indexGet) { return nameEntidad(values,indexGet)  }}
				},
				{
					thead: { th: 'Tipo', },
					tbody: { td: ['list_incapacidad/name'],}
				},
				{
					thead: { th: 'Días', },
					tbody: { td: ['info_incapacidades/dias'],}
				},
				{
					thead: { th: 'Proceso', sort: null, sortTable: 'info_incapacidades/id_list_proceso'},
					tbody: { td: ['list_proceso/name'],}
				},
				{
					thead: { th: 'F. Proceso', },
					tbody: { td: ['info_incapacidades/fechaproceso'],}
				},
				{
					thead: { th: 'Saldo', },
					tbody: { td: ['info_incapacidades/valor','info_egresos'], ftn: function(values){ let total=values[0]; if(values[1].length>0) { for (let i = 0; i < values[1].length; i++) {
						total = total-values[1][i]['valor'];
						
					}} return total}}
				},
				{
					thead: { th: 'Egresos', },
					tbody: { table: {
						value: false,
							tabla: 'info_egresos',
							search: ['name'],						
							items: [
								{
									thead: { th: 'Fecha'},
									tbody: {td: ['fecha']},
								},	
								{
									thead: { th: 'Descripcion'},
									tbody: {td: ['descripcion']},
								},
								{
									thead: { th: 'Valor'},
									tbody: {td: ['valor']},
								},
								{
									thead: { th: 'Egreso'},
									tbody: {td: ['id'], link: '/api/pdf/egresos',},
								},
								{
									thead: { th: 'Radicador'},
									tbody: {td: ['list_users/name']},
								},							
							]
						}
					}
				},
			]			
		}
	},
}